/**
 * A parent calendar the coach can't access (they only have one of its sub
 * calendars) comes back from the API with `id: null` and a placeholder name.
 * Build still shows it so the sub calendar has context, but it can't be opened.
 */

export const RESTRICTED_CALENDAR_TOOLTIP = 'You don\'t have permission to view or edit this calendar.';
export const RESTRICTED_CALENDAR_TOOLTIP_ID = 'restricted-calendar-tooltip';

/**
 * @param {Object} calendar a parent calendar, or a selection's parentCalendarInfo.
 * @returns {boolean} whether the coach is blocked from opening it.
 */
export const isRestrictedCalendar = (calendar) => calendar?.id == null;
